import { NotifyError, NotifySuccess } from "../Notify/notify";


export const GetAllPackages = (jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages', {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => {
        callback(res)
    })
    .catch(res => {
        console.log(res);
        NotifyError("Kunde inte hämta paket.");
    });
}

export const CreatePackage = (pkg, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages', {
        method: "POST",
        body: JSON.stringify({
            name: pkg.name,
            note: pkg.note,
            fotName: pkg.fotName
        }),
        headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(async res => {
        if(res.status >= 300){
            return res.text();
        } else {
            return res.json();
        }
    })
    .then(res => {
        NotifySuccess("Paket tillagt!");
        callback(res)
    })
    .catch(res => {
        NotifyError("Kunde inte lägga till paket.");
    });
}

export const UpdatePackage = (pkg, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages', {
        method: "PUT",
        body: JSON.stringify({
            id: pkg.id,
            name: pkg.name,
            fotName: pkg.fotName,
            note: pkg.note,
            placedAt: pkg.placedAt
        }),
        headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => {
        NotifySuccess("Paket uppdaterat!");
        callback(res)
    })
    .catch(res => {
        NotifyError("Kunde inte uppdatera paket.");
    });
}

export const CreateProductType = (name, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages/product', {
        method: "POST",
        body: JSON.stringify({ name }),
        headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => {
        NotifySuccess("Produkttyp skapad!");
        callback(res);
    })
    .catch(() => NotifyError("Kunde inte skapa produkttyp."));
}

export const DeleteProductType = (name, jwtToken, callback, onBlocked) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages/product/' + encodeURIComponent(name), {
        method: "DELETE",
        headers: { Authorization: `Bearer ${jwtToken}` }
    })
    .then(async res => {
        if (res.status === 409) {
            const msg = await res.text();
            onBlocked(msg);
        } else {
            NotifySuccess("Produkttyp borttagen!");
            callback();
        }
    })
    .catch(() => NotifyError("Kunde inte ta bort produkttyp."));
}

export const GetDeletedPackages = (jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages/deleted', {
        headers: { Authorization: `Bearer ${jwtToken}` }
    })
    .then(res => res.json())
    .then(res => callback(res))
    .catch(() => NotifyError("Kunde inte hämta historik."));
}

export const RestorePackage = (pkg, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages/' + pkg.id + '/restore', {
        method: "POST",
        headers: { Authorization: `Bearer ${jwtToken}` }
    })
    .then(res => res.json())
    .then(res => {
        NotifySuccess("Paket återställt!");
        callback(res.restored, res.newPlaceholder);
    })
    .catch(() => NotifyError("Kunde inte återställa paket."));
}

export const MarkPackageHandled = (pkg, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/packages/' + pkg.id, {
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => {
        NotifySuccess("Paket hanterat!");
        callback(res)
    })
    .catch(res => {
        NotifyError("Kunde inte hantera paket.");
    });
}
